export default "__VITE_ASSET__1cc4d87d__"